import { render } from "./App.vue?vue&type=template&id=6a7b7067"
import script from "./App.vue?vue&type=script&lang=ts"
export * from "./App.vue?vue&type=script&lang=ts"

import "./App.vue?vue&type=style&index=0&lang=stylus"
script.render = render

export default script